import { render } from "./DialogSendMessageComplete.vue?vue&type=template&id=0bc07b44&scoped=true"
import script from "./DialogSendMessageComplete.vue?vue&type=script&lang=js"
export * from "./DialogSendMessageComplete.vue?vue&type=script&lang=js"

import "./DialogSendMessageComplete.vue?vue&type=style&index=0&id=0bc07b44&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc07b44"]])

export default __exports__